import { DatePicker, Tabs } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import '../../styles.scss';

import { SettingOutlined } from '@ant-design/icons';
import { PaginationProps } from 'antd/lib';
import dayjs from "dayjs";
import ReactECharts from "echarts-for-react";
import { useSelector } from 'react-redux';
import { ICustomerDetail_V4 } from '../../../../api/customer/customerApi';
import { FieldsUpdate, getInvoiceSummaryByMonth, getListFieldsByCustomer, getListSaleInvoices, getListServiceInvoices, ICustomer, IInvoiceSummaryByMonth, ListField, updateFieldUser } from '../../../../api/Customer_V2/customerApi_V2';
import { Dashboard } from '../../../../components/ExportImgFigma';
import { SHOW_KEYNAME } from '../../../../env';
import useDebounce from '../../../../hook/useDebounce';
import useLoading from '../../../../hook/useLoading';
import useThrottle from '../../../../hook/useThrottle';
import useToast from '../../../../hook/useToast';
import { FIELDTYPE, NO_VIEW } from '../../../../services/data';
import { formatNumber } from '../../../../services/mixin';
import { selectorCategoryCarIds } from '../../../../store/slices/categoryCarSlice';
import { selectorInfoUser } from '../../../../store/slices/infoUserSlice';
import { flattenFields } from '../../../../until';
import { IPagination } from '../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup';
import { FlattenedField } from '../../../CustomersV2/indexV2';
import ServiceRecordFeilds from '../ServiceRecords/Components/ServiceRecordFeilds';
import TabServiceMaintenanceInvoice from './TabInvoiceHistory/TabServiceMaintenanceInvoice';
import TabVehicleInvoice from './TabInvoiceHistory/TabVehicleInvoice';
import { IDataDefaulFilterCar } from '../ServiceRecords/Components/FilterHeaderCar/FilterHeaderCar';

interface IDataFilterActive {
    vehicleInvoice: FlattenedField[];
    serviceMaintenanceInvoice: FlattenedField[];
}
interface IDataFilterNoActive {
    vehicleInvoice: ListField[];
    serviceMaintenanceInvoice: ListField[];
}

const EMPTY_GROUP = {
    vehicleInvoice: [],
    serviceMaintenanceInvoice: [],
};

type PaginationKey = "vehicleInvoice" | "serviceMaintenanceInvoice";

interface Props {
    infoCustomer?: ICustomerDetail_V4;

}
const TabInvoiceHistory: React.FC<Props> = ({
    infoCustomer
}) => {
    const pushToast = useToast();
    const pushLoading = useLoading()
    const { id, unitTemp } = useSelector(selectorInfoUser)
    const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

    useEffect(() => {
        gListFieldsActive()
    }, [])

    const { id: idCustomer } = infoCustomer ?? {}

    const [isSettingShow, setSettingShow] = useState(false)
    const [loadedTabs, setLoadedTabs] = useState({
        vehicleInvoice: false,
        serviceMaintenanceInvoice: false,
    });


    const [loadingTable, setLoadingTable] = useState(false)

    const [activeTab, setActiveTab] = useState<PaginationKey>("vehicleInvoice");
    const [year, setYear] = useState<number>(new Date().getFullYear());
    const [dataFieldsActive, setDataFieldsActive] = useState<IDataFilterActive>(EMPTY_GROUP);
    const [dataFieldsNoActive, setDataFieldsNoActive] = useState<IDataFilterNoActive>(EMPTY_GROUP);
    const [paginationMap, setPaginationMap] = useState<Record<PaginationKey, IPagination>>({
        vehicleInvoice: { current: 1, pageSize: 10, total: 0 },
        serviceMaintenanceInvoice: { current: 1, pageSize: 10, total: 0 },
    });

    const [dataFilterListVehicleInvoice, setDataFilterListVehicleInvoice] = useState<IDataDefaulFilterCar>({})
    const [dataFilterListServiceMaintenanceInvoice, setDataFilterListServiceMaintenanceInvoice] = useState<IDataDefaulFilterCar>({})

    // const [invoiceSummary, setInvoiceSummary] = useState<IInvoiceSummary>()
    const [invoiceSummaryByMonth, setInvoiceSummaryByMonth] = useState<IInvoiceSummaryByMonth[]>([])

    const [vehicleInvoice, setVehicleInvoice] = useState<ICustomer[]>([]);
    const [serviceMaintenanceInvoice, setServiceMaintenanceInvoice] = useState<ICustomer[]>([]);
    // tính dữ liệu cho chart


    const gListFieldsActive = async () => {
        const [vehicleInvoiceRes, serviceMaintenanceInvoiceRes,] =
            await Promise.all([
                getListFieldsByCustomer(FIELDTYPE.VehicleInvoice, 1),
                getListFieldsByCustomer(FIELDTYPE.ServiceMaintenanceInvoice, 1),
            ]);

        const flattenedFieldsVehicleInvoice = flattenFields(vehicleInvoiceRes?.data ?? []);
        const flattenedFieldsServiceMaintenanceInvoice = flattenFields(serviceMaintenanceInvoiceRes?.data ?? []);

        setDataFieldsActive({
            vehicleInvoice: flattenedFieldsVehicleInvoice,
            serviceMaintenanceInvoice: flattenedFieldsServiceMaintenanceInvoice,
        });

        gListFieldsNotActive();
    };

    const gListFieldsNotActive = async () => {
        const [vehicleInvoiceNoActiveRes, serviceMaintenanceInvoiceNoActiveRes,] =
            await Promise.all([
                getListFieldsByCustomer(FIELDTYPE.VehicleInvoice, 0),
                getListFieldsByCustomer(FIELDTYPE.ServiceMaintenanceInvoice, 0),
            ]);
        setDataFieldsNoActive({
            vehicleInvoice: vehicleInvoiceNoActiveRes?.data ?? [],
            serviceMaintenanceInvoice: serviceMaintenanceInvoiceNoActiveRes?.data ?? [],
        });
    };

    const gInvoiceSummaryByMonth = async (id: number, year: number) => {
        pushLoading(true)
        const result = await getInvoiceSummaryByMonth(
            id, year
        )
        if (result?.status) {
            setInvoiceSummaryByMonth(result.data)
        } else {
            pushToast(result?.message, "error")
        }
        pushLoading(false)
    };

    const gListSaleInvoices = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
        if (!idCustomer) return;
        const { vehicleChassisNo, unitId } = dataFilterListVehicleInvoice ?? {}
        setLoadingTable(true)
        const result = await getListSaleInvoices(
            idCustomer, unitTemp, permittedCategoryCarIds,
            undefined, pageSize, pageCurent, vehicleChassisNo,
            unitId
        )
        if (result?.status) {
            setVehicleInvoice(result.data)
            setPaginationMap(prev => ({
                ...prev,
                vehicleInvoice: {
                    current: pageCurent,
                    pageSize,
                    total: result.total,
                },
            }));
        } else {
            pushToast(result?.message, "warning")
        }
        // 🔥 QUAN TRỌNG
        setLoadedTabs(prev => ({
            ...prev,
            vehicleInvoice: true,
        }));
        setLoadingTable(false)
    }, 1000)

    const gListServiceInvoices = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
        if (!idCustomer) return;
        setLoadingTable(true)
        const { vehicleChassisNo, branchId } = dataFilterListServiceMaintenanceInvoice ?? {}
        const result = await getListServiceInvoices(
            idCustomer, unitTemp, permittedCategoryCarIds,
            undefined, pageSize, pageCurent, vehicleChassisNo,
            branchId
        )
        if (result?.status) {
            setServiceMaintenanceInvoice(result.data)
            setPaginationMap(prev => ({
                ...prev,
                serviceMaintenanceInvoice: {
                    current: pageCurent,
                    pageSize,
                    total: result.total,
                },
            }));
        } else {
            pushToast(result?.message, "warning")
        }
        // 🔥 QUAN TRỌNG
        setLoadedTabs(prev => ({
            ...prev,
            serviceMaintenanceInvoice: true,
        }));
        setLoadingTable(false)
    }, 1000)

    const handleChangeYear = (date: dayjs.Dayjs, dateString: string | string[]) => {
        if (date) {
            setYear(date.year());
            if (infoCustomer?.id)
                gInvoiceSummaryByMonth(infoCustomer?.id, date.year())
        }

    };

    const onSaveVisibleFields = useThrottle(async (dataFilterActive: FlattenedField[], dataFilterNoActive: ListField[]) => {
        let result: any;
        const activeFields: FieldsUpdate[] = dataFilterActive.map(item => ({
            fieldId: item.id,
            isActive: 1, // hoặc true tùy bạn muốn mặc định là gì
        }));
        const allFieldsDefaultInactive: FieldsUpdate[] = dataFilterNoActive.flatMap(group =>
            group.fields.map(field => ({
                fieldId: field.id,
                isActive: 0,
            }))
        );
        const listActiveFields = activeFields.concat(allFieldsDefaultInactive)

        switch (activeTab) {

            case 'vehicleInvoice': {
                result = await updateFieldUser(id, FIELDTYPE.VehicleInvoice, undefined, listActiveFields)
                break;
            }
            case 'serviceMaintenanceInvoice': {
                result = await updateFieldUser(id, FIELDTYPE.ServiceMaintenanceInvoice, undefined, listActiveFields)
                break;
            }
            default:
                break;
        }

        if (result?.status) {
            pushToast(result?.message, "success")
            setSettingShow(false)

            if (dataFilterActive && dataFilterNoActive) {
                setDataFieldsActive(prev => ({
                    ...prev,
                    [activeTab]: dataFilterActive ?? [],
                }));

                setDataFieldsNoActive(prev => ({
                    ...prev,
                    [activeTab]: dataFilterNoActive ?? [],
                }));
            }

        } else {
            pushToast(result?.message, "warning")
        }
    }, 2000)

    const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        switch (activeTab) {
            case "vehicleInvoice": {
                gListSaleInvoices(pageNumber, pageSize)
                break;
            }
            case "serviceMaintenanceInvoice": {
                gListServiceInvoices(pageNumber, pageSize)
                break;
            }
            default:
                break;
        }
    }

    useEffect(() => {
        if (idCustomer) {
            // console.log(activeTab,dataFilterListServiceMaintenanceInvoice);

            switch (activeTab) {
                case "vehicleInvoice": {
                    gListSaleInvoices()
                    break;
                }
                case "serviceMaintenanceInvoice": {
                    gListServiceInvoices()
                    break;
                }
                default:
                    break;
            }
        }

    }, [idCustomer, dataFilterListVehicleInvoice, dataFilterListServiceMaintenanceInvoice])

    useEffect(() => {
        if (idCustomer) {
            gInvoiceSummaryByMonth(idCustomer, year)

            gListSaleInvoices()
            gListServiceInvoices()
        }
    }, [idCustomer])

    return (
        <Fragment>
            {
                isSettingShow ?
                    <ServiceRecordFeilds
                        isSettingShow={isSettingShow}
                        type={0}
                        dataFilterActive={dataFieldsActive[activeTab]}
                        dataFilterNoActive={dataFieldsNoActive[activeTab]}

                        onSaveVisibleFields={onSaveVisibleFields}
                        onClose={() => setSettingShow(false)}
                    /> :
                    null
            }
         
            <div className='custom-page-css w-full pb-3 flex flex-col gap-3'>
                <div className="custom-page-css w-full flex gap-3">
                    <div className="custom-page-css  flex flex-2 flex-col justify-around rounded border">
                        <div className="custom-page-css w-full flex items-center justify-around gap-4 p-3 border-b">
                            <div className="custom-page-css flex items-center justify-center gap-3">
                                <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full ">
                                    <img src={Dashboard} alt="" style={{ height: 16, width: 16, objectFit: 'contain' }} />
                                </div>
                                <span className='custom-page-css text-xl font-light  text-000000'>Tổng chi tiêu</span>
                            </div>
                            <span className='custom-page-css text-2xl font-light font-medium px-1  text-000000' {...(SHOW_KEYNAME === true && { 'col-id': 'total_info_summary.total_spending.total' })}>

                                {infoCustomer?.permissions?.totalAmount ? formatNumber(infoCustomer?.totalAmount ?? 0) : NO_VIEW}
                            </span>

                        </div>
                        <div className="custom-page-css px-2 flex flex-col justify-around">
                            <div className="custom-page-css flex py-2 flex-1 border-b">
                                <div className="custom-page-css py-2 flex flex-1 flex-col items-center justify-center gap-1 border-r">
                                    <span
                                        className='custom-page-css text-2xl font-light font-medium px-1  text-000000'
                                        {...(SHOW_KEYNAME === true && { 'col-id': 'total_vehicle_invoices' })}
                                    >
                                        
                                {infoCustomer?.permissions?.totalPurchaseInvoices ? formatNumber(infoCustomer?.totalPurchaseInvoices ?? 0) : NO_VIEW}
                                    </span>
                                    <span className='custom-page-css text-xl font-light text-center  text-000000'>SL hóa đơn mua xe </span>
                                </div>
                                <div className="custom-page-css py-2 flex flex-1 flex-col items-center justify-center gap-1 ">
                                    <span
                                        className='custom-page-css text-2xl font-light font-medium px-1  text-000000'
                                        {...(SHOW_KEYNAME === true && { 'col-id': 'total_service_invoices' })}
                                    >
                                         {infoCustomer?.permissions?.totalServiceInvoices ? formatNumber(infoCustomer?.totalServiceInvoices ?? 0) : NO_VIEW}
                                    </span>
                                    <span className='custom-page-css text-xl font-light text-center  text-000000'>SL hóa đơn dịch vụ</span>
                                </div>
                            </div>
                            <div className="custom-page-css flex py-2 flex-1 ">
                                <div className="custom-page-css py-2 flex flex-1 flex-col items-center justify-center gap-1 border-r">
                                    <span
                                        className='custom-page-css text-2xl font-light font-medium px-1  text-000000'
                                        {...(SHOW_KEYNAME === true && { 'col-id': 'total_vehicle_amount' })}
                                    >
                                            {infoCustomer?.permissions?.totalPurchaseAmount ? formatNumber(infoCustomer?.totalPurchaseAmount ?? 0) : NO_VIEW}
                                    </span>
                                    <span className='custom-page-css text-xl font-light text-center  text-000000'>Hóa đơn mua xe </span>
                                </div>
                                <div className="custom-page-css py-2 flex flex-1 flex-col items-center justify-center gap-1 ">
                                    <span
                                        className='custom-page-css text-2xl font-light font-medium px-1  text-000000'
                                        {...(SHOW_KEYNAME === true && { 'col-id': 'total_service_amount' })}
                                    >
                                         {infoCustomer?.permissions?.totalServiceAmount ? formatNumber(infoCustomer?.totalServiceAmount ?? 0) : NO_VIEW}
                                    </span>
                                    <span className='custom-page-css text-xl font-light text-center  text-000000'>Hóa đơn dịch vụ</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="custom-page-css  flex flex-5 flex-col rounded border">
                        <div style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: 16 }}>
                            {/* Title + DatePicker cùng hàng */}
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                                <span className='custom-page-css font-bold  text-xl  text-344054'>
                                    Thống kê số lượng hóa đơn giao dịch trong năm
                                </span>
                                <DatePicker
                                    picker="year"
                                    defaultValue={dayjs(`${year}`, "YYYY")}
                                    onChange={handleChangeYear}
                                />
                            </div>

                            {/* Chart */}
                            <ReactECharts
                                option={{
                                    tooltip: {
                                        trigger: 'axis',
                                        axisPointer: { type: 'shadow' },
                                    },
                                    legend: {
                                        bottom: 0,
                                        data: ['Hóa đơn mua xe', 'Hóa đơn dịch vụ'],
                                    },
                                    grid: {
                                        left: 70,
                                        right: 20,
                                        top: 40,
                                        bottom: 60,
                                    },
                                    xAxis: {
                                        type: 'category',
                                        data: invoiceSummaryByMonth.map(item => `Tháng ${item.month}`),
                                        axisTick: { show: false },
                                    },
                                    yAxis: {
                                        type: 'value',
                                        min: 0,
                                        minInterval: 1,
                                        axisLabel: {
                                            formatter: (value: number) => value.toString(),
                                        },
                                    },
                                    series: [
                                        {
                                            name: 'Hóa đơn mua xe',
                                            type: 'bar',
                                            stack: 'total',
                                            barWidth: 24,
                                            data: invoiceSummaryByMonth.map(item => item.saleTotal),
                                            itemStyle: {
                                                color: {
                                                    type: 'linear',
                                                    x: 0,
                                                    y: 0,
                                                    x2: 0,
                                                    y2: 1,
                                                    colorStops: [
                                                        { offset: 0, color: '#3B82F6' }, // xanh đậm
                                                        { offset: 1, color: '#BFDBFE' }, // xanh nhạt
                                                    ],
                                                },
                                                borderRadius: [4, 4, 0, 0],
                                            },
                                        },
                                        {
                                            name: 'Hóa đơn dịch vụ',
                                            type: 'bar',
                                            stack: 'total',
                                            barWidth: 24,
                                            data: invoiceSummaryByMonth.map(item => item.serviceTotal),
                                            itemStyle: {
                                                color: {
                                                    type: 'linear',
                                                    x: 0,
                                                    y: 0,
                                                    x2: 0,
                                                    y2: 1,
                                                    colorStops: [
                                                        { offset: 0, color: '#F43F5E' }, // đỏ hồng đậm
                                                        { offset: 1, color: '#FECACA' }, // đỏ nhạt
                                                    ],
                                                },
                                                borderRadius: [4, 4, 0, 0],
                                            },
                                        },
                                    ],
                                }}
                                style={{ height: 320, width: '100%' }}
                            />
                        </div>
                    </div>
                </div>
                <div className="custom-page-css w-full flex items-center justify-between gap-3 pt-3 relative">
                    <Tabs
                        className='w-full'
                        activeKey={activeTab}
                        items={
                            [
                                {
                                    key: 'vehicleInvoice',
                                    label: <span className='custom-page-css font-light text-lg'>Hoá đơn xe</span>,
                                    children:
                                        <TabVehicleInvoice
                                            loadingTable={loadingTable}
                                            dataFieldsActive={dataFieldsActive.vehicleInvoice}
                                            pagination={paginationMap.vehicleInvoice}
                                            idCustomer={infoCustomer?.id}
                                            dataFilterList={dataFilterListVehicleInvoice}
                                            data={vehicleInvoice}

                                            setDataFilterList={setDataFilterListVehicleInvoice}
                                            onPaginationChange={onPaginationChange}
                                        />,
                                },
                                {
                                    key: 'serviceMaintenanceInvoice',
                                    label: <span className='custom-page-css font-light text-lg'>Hoá đơn bảo trì dịch vụ</span>,
                                    children:
                                        <TabServiceMaintenanceInvoice
                                            loadingTable={loadingTable}
                                            dataFieldsActive={dataFieldsActive.serviceMaintenanceInvoice}
                                            pagination={paginationMap.serviceMaintenanceInvoice}
                                            idCustomer={infoCustomer?.id}
                                            dataFilterList={dataFilterListServiceMaintenanceInvoice}
                                            data={serviceMaintenanceInvoice}

                                            setDataFilterList={setDataFilterListServiceMaintenanceInvoice}
                                            onPaginationChange={onPaginationChange}
                                        />,
                                },
                            ]
                        }
                        onChange={(e) => setActiveTab(e as PaginationKey)}
                    />

                    <div className="custom-page-css absolute top-4 right-0">
                        <div className='settingCol'>
                            <div className='ctr-col-setting'
                                onClick={() => setSettingShow(true)}
                            >
                                <SettingOutlined />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
export default TabInvoiceHistory
